<template>
    <div>
        <el-dialog title="设置实例"
            :visible="visible"
            @close="cancel"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            width="80%">
         <el-form :model="instanceObj" ref="instanceObj" name="instanceObj" label-width="100px" class="instanceDiv">
             <el-form-item label="服务模式">
                <el-switch
                    v-model="instanceObj.service.serviceMode"
                    active-color="#13ce66">
                </el-switch>
             </el-form-item>
             <el-form-item label="服务名称" :prop="'service.name'"
                :rules="instanceObj.service.serviceMode ? {} : [{required: true, message: '必填项'},{ validator: validateName}]">
                 <el-input v-model="instanceObj.service.name" class="butel_input" :disabled="instanceObj.service.serviceMode"></el-input>
             </el-form-item>
             <el-form-item label="容器" v-if="!instanceObj.service.serviceMode"
                prop="containerType" :rules="{required: true, message: '必填项'}">
                <div class="butel_input">
                    <el-col :span="12">
                        <el-select v-model="instanceObj.containerType"
                            placeholder="请选择容器类型"
                            @change="chooseContainerType">
                            <el-option v-for="(option, index) in containerTypes"
                            :key="index"
                            :value="option.type"
                            :label="option.type"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="12" style="text-align: right;">
                        <el-select
                            v-model="instanceObj.containerId"
                            @change="getDefaultPath"
                            placeholder="请选择容器实例">
                            <el-option v-for="(option, index) in containerInstanceList"
                            :key="index"
                            :value="option.id"
                            >
                                <span style="float: left">{{ '实例'+option.id }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">
                                    {{ option.alias }}
                                </span>
                            </el-option>
                        </el-select>
                    </el-col>
                </div>
             </el-form-item>
             <el-form-item label="部署路径" :prop="'service.workspace'" :rules="instanceObj.service.serviceMode ? {} : {required: true, message: '必填项'}">
                 <el-input
                    v-model="instanceObj.service.workspace"
                    @focus="oldWorkspace = instanceObj.service.workspace"
                    @blur="changeLogPath"
                    class="butel_input"></el-input>
             </el-form-item>
             <el-form-item label="实例别名">
                 <el-input v-model="instanceObj.alias" class="butel_input"></el-input>
             </el-form-item>

           <el-form-item label="日志">
             <div v-for="(item, idx) in instanceObj.service.logs" :key="idx" style="margin-bottom:20px;">
               <el-form :inline="true">
                 <el-form-item label="日志目录">
                   <el-input v-model="item.path"></el-input>
                 </el-form-item>
                 <el-form-item label="备份目录">
                   <el-input v-model="item.backupPath"></el-input>
                 </el-form-item>
                 <el-form-item label="日志名称">
                   <el-input v-model="item.name"></el-input>
                 </el-form-item>
                 <i class="el-icon-circle-plus" style="margin: 0 20px;"
                    @click="addLogPath(idx)"></i>
                 <i v-if="instanceObj.service.logs.length > 1" class="el-icon-delete-solid"
                    @click="delLogPath(idx)"></i>
               </el-form>
             </div>
           </el-form-item>

            <div style="text-align:center;">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </div>
         </el-form>
        </el-dialog>

        <el-dialog title="提示" :visible="showTip">
            <div class="result">操作成功！</div>
            <div class="desc">即将进入列表页，是否继续？</div>
            <i class="time"><b>{{countdown}}</b>...</i>
            <div style="text-align:center;">
                <el-button type="primary" @click="yes">是</el-button>
                <el-button  @click="no">否</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { Loading } from "element-ui";
export default {
    name: 'InstanceEdit',
    props: {
        visible: {
            type: Boolean
        },
        id: {
            type: [String, Number]
        },
        isEdit: {
            type: Boolean
        },
        // 实例是否已安装成功，如果安装成功，不允许修改部署路径
        installSuccess: {
            type: Boolean
        }
    },
    data: vm=> ({
        validateName: (rule, value, callback)=>{
            const reg = /^[_a-zA-Z0-9]+$/
            if (value == '' || value == undefined || value == null) {
                callback()
            } else {
                if (!reg.test(value)) {
                    callback(new Error('只能输入英文字母，数字以及下划线'))
                } else {
                    callback()
                }
            }
        },
        instanceObj: {
            id: '',
            alias: '',
            service: {
                serviceMode: true,
                workspace: '',
                logs: [{
                    name: '',
                    path: ''
                }]
            },
            containerId: '',
            containerType: '',
        },
        countdown: 5,
        showTip: false,
        timer: '',
        containerInstanceList: [],
        oldWorkspace: '',
    }),
    created(){
        if(this.isEdit){
            this.findById()
        }
    },
    watch: {
        id: {
            handler (newVal, oldVal) {
                this.instanceObj.id = newVal
            }
        }
    },
    methods: {
        // 部署路径修改后自动修改第一个日志目录
        changeLogPath(){
            if(this.instanceObj.service.logs.length > 0
            && this.instanceObj.service.logs[0].path){
                const path = this.instanceObj.service.logs[0].path
                if(path.includes(this.oldWorkspace)){
                  this.instanceObj.service.logs[0].path = path.replace(this.oldWorkspace, this.instanceObj.service.workspace)
                }
            }
        },
        // 获取实例的默认部署路径
        getDefaultPath(id){
            this.$axios.get(this.baseUrl3 + 'instance/getDeployPath/' + this.instanceObj.id
                            + '/' + (id ? id : 0))
            .then(({data:{code, data, msg}}) => {
                if(code != 20000){
                    this.$message.error('查找模块的实例列表失败：'+msg)
                }else{
                    this.instanceObj.service.workspace = data ? data.defaultDeployPath : ''

                    // 非服务模式，带后缀；服务模式显示默认路径
                    if(!this.instanceObj.service.serviceMode && this.instanceObj.containerType){
                        let suffix = ''
                        const conType = this.instanceObj.containerType
                        suffix = this.containerTypes.filter(ct => ct.type ==conType)[0].suffix
                        if(this.instanceObj.service.workspace){
                            this.instanceObj.service.workspace = this.instanceObj.service.workspace + "/" + suffix
                        }

                    }

                    if(data && data.defaultLogPath){
                        this.instanceObj.service.logs[0].path = data.defaultLogPath
                    }
                    if(data && data.defaultBackupLogPath){
                        this.instanceObj.service.logs[0].backupPath = data.defaultBackupLogPath
                    }
                    if(data && data.defaultLogName){
                        this.instanceObj.service.logs[0].name = data.defaultLogName
                    }
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        // 选择容器类型后查询实例列表
        chooseContainerType(containerType, containerId){
            this.instanceObj.containerId = containerId ? containerId : ''
            this.containerInstanceList = []

            // this.$axios.get(this.baseUrl + 'instance/findAllByModuleType/' + containerType
            // +'/' + this.instanceObj.deviceId)
            this.$axios.get(this.baseUrl3 + 'instance/findAllByDeviceAndModuleType/' +
            this.instanceObj.deviceId +'/' + containerType)
            .then(({data:{code, data, msg}}) => {
                if(code != 20000){
                    this.$message.error('查找模块的实例列表失败：'+msg)
                }else{
                    this.containerInstanceList = data
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        findById(){
            if(!this.id){
                return
            }
            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            this.$axios.get(this.baseUrl3 + "instance/findById/"+ this.id)
                .then(({ data: { msg, data, code } }) => {
                    if(code == 20000){
                        let service = data.service ? data.service : {}
                        this.instanceObj = {
                            id: data.id,
                            alias: data.alias,
                            deviceId: data.deviceId,
                            service: {
                                serviceMode: service.serviceMode,
                                workspace: service.workspace,
                                logs: service.logs ? service.logs : [{
                                    path: '',
                                    name: ''
                                }],
                                name: service.name
                            },
                            containerType: data.containerType,
                            containerId: data.containerId ? parseInt(data.containerId) : 0
                        }
                        if(data.containerType){
                            this.chooseContainerType(data.containerType, data.containerId)
                        }
                        // 如果实例部署路径为空，显示默认路径
                        if(!data.service.workspace && data.service.serviceMode){
                            this.getDefaultPath()
                        }
                    }else{
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                    loading.close();
                }).catch(err=>{
                    loading.close();
                })

        },
        addLogPath(idx){
            this.instanceObj.service.logs.splice(idx+1, 0, {
                log: '', name: '', type: ''
            })
        },
        delLogPath(idx){
            this.instanceObj.service.logs.splice(idx, 1)
        },
        yes(){
            this.$emit('instanceEditCallback', false)
            this.$router.push('instancelist')
            this.timer ? clearInterval(this.timer) : true
        },
        no(){
            this.$emit('instanceEditCallback', this.instanceObj)
            this.timer ? clearInterval(this.timer) : true
            this.showTip = false
        },
        cancel(){
            this.$emit('instanceEditCallback', false)
        },
        save(){
            // console.log(this.instanceObj)
            this.$refs['instanceObj'].validate(valid => {
                if(valid){
                    let loading = Loading.service({
                        fullscreen: true,
                        text: "数据加载中..."
                    });
                    this.$axios.post(this.baseUrl3 + "instance/edit", this.instanceObj)
                        .then(({ data: { msg, data, code } }) => {
                            if(code == 20000){
                                // this.cancel()

                                if(this.isEdit != true){
                                    this.showTip = true
                                    this.timer = setInterval(()=>{
                                        this.countdown--
                                        if(this.countdown == 0){
                                            clearInterval(this.timer)
                                            this.$router.push('instancelist')
                                        }
                                    }, 1000);
                                    this.cancel()
                                }else{
                                    this.$emit('instanceEditCallback', data)
                                }

                            }else{
                                this.$message({ showClose: true, message: msg, type: "error" });
                                console.log(msg);
                            }
                            loading.close();
                        }).catch(err => {
                            loading.close();
                        });
                }else{
                    console.log('表单验证不通过')
                }
            })


        }
    }
}
</script>
<style scoped>
.instanceDiv .butel_input{
    width: 78%;
}
.butel_input_inner{
    width: 30%;
}

.result{
    color: #67C23A;
    font-weight: bold;
}
.desc, .time, .result{
    font-size: 20px;
    margin: 15px 20px;
}
</style>
